import styled from '@emotion/styled';

export const StyledTableTopButtons = styled.div`
  padding: 15px 0;
  display: flex;
  justify-content: flex-end;
  align-items: center;
`;
